import axiosInstance from './axios';

export const couponService = {
  getCoupons: async (params = {}) => {
    const response = await axiosInstance.get('/coupons', { params });
    return response.data;
  },

  getCoupon: async (id) => {
    const response = await axiosInstance.get(`/coupons/${id}`);
    return response.data;
  },

  createCoupon: async (couponData) => {
    const response = await axiosInstance.post('/coupons', couponData);
    return response.data;
  },

  updateCoupon: async (id, couponData) => {
    const response = await axiosInstance.put(`/coupons/${id}`, couponData);
    return response.data;
  },

  deleteCoupon: async (id) => {
    const response = await axiosInstance.delete(`/coupons/${id}`);
    return response.data;
  },

  getCouponStatistics: async (id) => {
    const response = await axiosInstance.get(`/coupons/${id}/statistics`);
    return response.data;
  },
};
